<div class="tooltip">
	<div class="tooltip-content">
		<perfect-scrollbar>
			<ng-template tooltip-host></ng-template>
		</perfect-scrollbar>
	</div>
</div>